import { AuthService } from "../../services/AuthService.js";
import { AppConfig } from "../../utils/AppConfig.js";
import { TemplateEngine } from "../../utils/TemplateEngine.js";
import { ProfileController } from "../../../profile/ProfileController.js";
import { TourService } from "../../utils/TourService.js";
import { VistaService } from "../../utils/VistaService.js";
import navbarTemplate from "./navbar.html?raw";

export const Navbar = {
  render: async() => {
    const user = AuthService.getCurrentUser();

    const data = {
      appName: AppConfig.app.name,
      appVersion: AppConfig.app.version,
      userName: user?.nombre || "Usuario",
      // Los usuarios de un proveedor externo pueden no tener email: se muestra su usuario
      userEmail: user?.email || user?.usuario || "",
      userRol: user?.rol || "user",
      userInitial: (user?.nombre || "U").charAt(0).toUpperCase(),
      isAdmin: user?.rol === "admin",
      // Admin o editor de alguna categoría: ven el acceso al panel
      puedeGestionar: AuthService.puedeGestionar(user),
      isDevelopment: AppConfig.isDevelopment(),
      globalSearch: AppConfig.features.globalSearch,
      tourBtnLabel: TourService.hasSeen() ? "Repetir recorrido" : "Hacer recorrido",
    };

    const html = TemplateEngine.render(navbarTemplate, data);

    setTimeout(() => {
      // ── Offcanvas nav links: Bootstrap's data-bs-dismiss prevents default href
      // so we navigate manually and close the offcanvas ourselves.
      const offcanvasEl = document.getElementById("navOffcanvas");
      document.querySelectorAll("#offcanvas-nav-links a[href]").forEach(link => {
        if (!link.hasAttribute("data-nav-listener")) {
          link.addEventListener("click", (e) => {
            e.preventDefault();
            const hash = link.getAttribute("href").replace(/^#/, "");
            if (offcanvasEl) bootstrap.Offcanvas.getInstance(offcanvasEl)?.hide();
            window.location.hash = hash;
          });
          link.setAttribute("data-nav-listener", "true");
        }
      });

      // ── Vista chat: el enlace navega y deja la preferencia guardada ───────
      document.querySelectorAll("[data-vista]").forEach(link => {
        if (!link.hasAttribute("data-vista-listener")) {
          link.addEventListener("click", () => VistaService.set(link.dataset.vista));
          link.setAttribute("data-vista-listener", "true");
        }
      });

      // ── Desktop dropdown buttons ──────────────────────────────────────────
      const logoutBtn = document.getElementById("logoutBtn");
      if (logoutBtn && !logoutBtn.hasAttribute("data-listener-added")) {
        logoutBtn.addEventListener("click", (e) => {
          e.preventDefault();
          AuthService.logout();
        });
        logoutBtn.setAttribute("data-listener-added", "true");
      }

      const profileBtn = document.getElementById("profileBtn");
      if (profileBtn && !profileBtn.hasAttribute("data-listener-added")) {
        profileBtn.addEventListener("click", (e) => {
          e.preventDefault();
          ProfileController.open();
        });
        profileBtn.setAttribute("data-listener-added", "true");
      }

      const tourBtn = document.getElementById("tourBtn");
      if (tourBtn && !tourBtn.hasAttribute("data-listener-added")) {
        tourBtn.addEventListener("click", (e) => {
          e.preventDefault();
          const u = AuthService.getCurrentUser();
          TourService.start(u?.rol === "admin");
        });
        tourBtn.setAttribute("data-listener-added", "true");
      }

      // ── Offcanvas user section buttons ────────────────────────────────────
      const offcanvasLogout = document.getElementById("offcanvas-logoutBtn");
      if (offcanvasLogout && !offcanvasLogout.hasAttribute("data-listener-added")) {
        offcanvasLogout.addEventListener("click", (e) => {
          e.preventDefault();
          AuthService.logout();
        });
        offcanvasLogout.setAttribute("data-listener-added", "true");
      }

      const offcanvasProfile = document.getElementById("offcanvas-profileBtn");
      if (offcanvasProfile && !offcanvasProfile.hasAttribute("data-listener-added")) {
        offcanvasProfile.addEventListener("click", (e) => {
          e.preventDefault();
          if (offcanvasEl) bootstrap.Offcanvas.getInstance(offcanvasEl)?.hide();
          ProfileController.open();
        });
        offcanvasProfile.setAttribute("data-listener-added", "true");
      }

      const offcanvasTour = document.getElementById("offcanvas-tourBtn");
      if (offcanvasTour && !offcanvasTour.hasAttribute("data-listener-added")) {
        offcanvasTour.addEventListener("click", (e) => {
          e.preventDefault();
          if (offcanvasEl) bootstrap.Offcanvas.getInstance(offcanvasEl)?.hide();
          const u = AuthService.getCurrentUser();
          TourService.start(u?.rol === "admin");
        });
        offcanvasTour.setAttribute("data-listener-added", "true");
      }

      // ── Desktop search ────────────────────────────────────────────────────
      const searchForm = document.getElementById("navbar-search-form");
      if (searchForm && !searchForm.hasAttribute("data-listener-added")) {
        searchForm.addEventListener("submit", (e) => {
          e.preventDefault();
          const q = document.getElementById("navbar-search-input")?.value?.trim();
          if (q) window.location.hash = `knowledge?q=${encodeURIComponent(q)}`;
        });
        searchForm.setAttribute("data-listener-added", "true");
      }

      // ── Mobile search ─────────────────────────────────────────────────────
      const searchFormMobile = document.getElementById("navbar-search-form-mobile");
      if (searchFormMobile && !searchFormMobile.hasAttribute("data-listener-added")) {
        searchFormMobile.addEventListener("submit", (e) => {
          e.preventDefault();
          const q = document.getElementById("navbar-search-input-mobile")?.value?.trim();
          if (q) {
            if (offcanvasEl) bootstrap.Offcanvas.getInstance(offcanvasEl)?.hide();
            window.location.hash = `knowledge?q=${encodeURIComponent(q)}`;
          }
        });
        searchFormMobile.setAttribute("data-listener-added", "true");
      }
    }, 10);

    return html;
  },
};
